import React from 'react';
import {Box} from '@mui/material';
import DateFnsUtils from '@date-io/date-fns';
import numberFormat from 'utils/tables/renderers/numberFormat';
import {REPORT_DATETIME_FORMAT} from '../../../constants/reports';

const dateFns = new DateFnsUtils();

export const TOP_UP_REQUESTS_COLUMN_DEFS = [
    {
        accessorKey: 'id',
        header: 'Id',
        enableResizing: true,
    },
    {
        accessorKey: 'transactionNumber',
        header: 'Transaction',
        enableResizing: true,
    },

    {
        accessorKey: 'client',
        header: 'Client',
        enableResizing: true,
    },

    {
        accessorKey: 'ugwPublisher',
        header: 'Publisher',
        enableResizing: true,
    },

    {
        accessorKey: 'ugwPublisherEndpoint',
        header: 'Endpoint',
        enableResizing: true,
    },
    {
        accessorKey: 'clientPublisher',
        header: 'Client Publisher',
        enableResizing: true,
    },
    {
        accessorKey: 'deposit',
        header: 'Deposit ($)',
        Cell: ({cell}) => numberFormat(cell.getValue()),
        Footer: ({table}) => {
           const totals = table.options.meta?.totals || {};
           const deposits = totals.deposits || 0;

            return (
              <Box sx={{fontWeight: 'bold', fontSize: '14px'}}>
                {
                   deposits.toLocaleString('en-US', {
                     style: 'currency',
                     currency: 'USD',
                   })
                }
              </Box>
            );
        },
        enableResizing: true,
    },
    {
        accessorKey: 'status',
        header: 'Status',
        Cell: ({cell}) => {
            const value = cell.getValue()?.toLowerCase?.();
            const bgColor = {
                succeeded: '#3ed436',
                canceled: '#ad210f',
                pending: '#f6ab2e',
                new: '#1578b6',
            }[value] || '#ccc';

            return (
              <Box
                sx={{
                  backgroundColor: bgColor,
                  color: 'white',
                  borderRadius: '4px',
                  px: 1,
                  py: 0.5,
                  display: 'inline-block',
                }}
              >
                {cell.getValue()}
              </Box>
            );
        },
        enableResizing: true,
    },
    {
        accessorKey: 'statusReason',
        header: 'Status Reason',
        enableResizing: true,
    },
    {
        accessorKey: 'createdAt',
        header: 'Timestamp',
        Cell: ({cell}) => dateFns.format(new Date(cell.getValue()), REPORT_DATETIME_FORMAT),
        enableResizing: true,
    },
];
